/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';

import Colors from 'constants/Colors';
import { FontWeight, FiraSansBold } from 'components/Text';
import { Breakpoints } from 'constants/Breakpoints';
// import { Breakpoints } from '../../../../../../../constants/Breakpoints';

export const Text = styled.text`
  color: ${props => props.secundary ? Colors.BLUE : Colors.GRAY[6]};
  font-weight: ${FontWeight.SemiBold};
  font-size: 16px;
  cursor: pointer;

  @media screen and (max-width: ${Breakpoints.sm}) {
    font-size: 12px;
  }
`;

export const IconButton = styled.button`
  display: flex;
  width: 50px;
  height: 50px;
  border: 0px;
  background-color:transparent;
  cursor: pointer;
  align-self: flex-end;
  margin: 0px;
  padding: 0;
  margin-bottom: 20px;
`;

export const Title = styled.label`
  font-size: 16px;
  color: ${Colors.GRAY[6]};
  ${FiraSansBold}
`;